export enum EMusicItemType {
  audio = 'audio',
  folder = 'folder',
}
